import get from 'lodash.get';

declare interface GetShallowNodeValueFunction {
  <TNode extends object, TKey extends keyof TNode>(node: TNode, path: TKey): TNode[TKey];
  (node: any, path: string): any;
}

/**
 * Get the value of a node at a given path.
 */
export const getShallowNodeValue: GetShallowNodeValueFunction = (node: any, path: string) => {
  return get(node, path);
};
